export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["xxl"] = "xxl";
    Breakpoint["xl"] = "xl";
    Breakpoint["lg"] = "lg";
    Breakpoint["md"] = "md";
    Breakpoint["sm"] = "sm";
    Breakpoint["xs"] = "xs";
})(Breakpoint || (Breakpoint = {}));
